import { Stack, Typography } from '@mui/material';

import React, { useEffect, useState } from 'react';

import DOMPurify from 'dompurify';

import { ApiResponse } from 'common/api/api-wrapper';
import { ReactComponent as SuggestedPrompts } from 'common/assets/images/suggested-prompts.svg';
import { Loader } from 'common/components/Loader/Loader';
import { HTTP_STATUS_CODES } from 'common/constants/HttpStatusConstants';

import { getPreGeneratedPrompts } from '../api';
import { IPromptData } from '../api/type-def';
import { onPromptSelect } from '../OpenRiskGPTUtil';

import promptLibraryStyles from './PromptLibrary.module.scss';

interface IPromptList {
	selectedRole: string | null;
	setSearchVal: (value: string, role: string) => void;
	setCursorPosition: any;
}

const PromptList = (props: IPromptList) => {
	const { selectedRole, setCursorPosition, setSearchVal } = props;
	const { OK } = HTTP_STATUS_CODES;

	const [isPromptLoading, setIsPromptLoading] = useState<boolean>(true);
	const [promptData, setPromptData] = useState<any[]>([]);

	const fetchPreGeneratedPrompts = async (role: string | null) => {
		setIsPromptLoading(true);
		const response: ApiResponse<any, any> = await getPreGeneratedPrompts(
			role,
			!role,
		);
		setIsPromptLoading(false);
		if (response?.statusCode === OK) {
			setPromptData(response?.responseBody?.data);
		} else {
			setPromptData([]);
		}
	};

	useEffect(() => {
		fetchPreGeneratedPrompts(selectedRole);
	}, [selectedRole]);

	return (
		<>
			<Stack
				direction="row"
				alignItems="center"
				spacing={1}
				className={promptLibraryStyles['prompts-header']}
			>
				<Typography className={promptLibraryStyles['header-style']}>
					{selectedRole ? 'Prompts' : 'Suggested prompts'}
				</Typography>
				<SuggestedPrompts />
			</Stack>
			<div>
				{' '}
				{!isPromptLoading ? (
					promptData?.map((data: IPromptData) => (
						<Typography
							key={data?.prompt}
							className={promptLibraryStyles['prompt-text']}
							onClick={() =>
								onPromptSelect(data, setCursorPosition, setSearchVal)
							}
							data-testid="prompt-title"
							dangerouslySetInnerHTML={{
								__html: DOMPurify.sanitize(data?.prompt),
							}}
						/>
					))
				) : (
					<Loader show />
				)}
			</div>
		</>
	);
};

export default PromptList;
